<template>
  <div class="cashflow-type-tracking-category card-box">
    <div class="title">
      <span>{{ titles.cardTitle }}</span>
    </div>

    <expense-progress :up-to-now-label="titles.expenseProgress.actualsLabel"
                      :up-to-now-amount="subtree.upToNowAmount"
                      :show-warning-if-exceeding-budget="false"/>

    <predicted-category-sections :actuals-title="titles.categorySections.actualsTitle"
                                 :categories="subtree.categories"
                                 :initially-expanded="false"
                                 :show-recommended-title="false"
                                 :title="titles.categorySections.mainTitle"
                                 v-on:section-clicked="sectionClicked(CASHFLOW_TYPE, $event)"
                                 v-on:category-sections-clicked="categorySectionsClicked(CASHFLOW_TYPE, $event)">
      <template v-slot:transactions="{ transactions }">
        <div class="transaction-list">
          <transaction class="transaction-details"
                                     v-for="transaction in transactions"
                                     :transaction="transaction"
                                     :can-edit-category="true"
                                     :category-name="TRACKING_CATEGORY"
                                     :category-id="subtree.categoryId"
                                     v-bind:key="transaction.transactionId">

          </transaction>
        </div>
      </template>
    </predicted-category-sections>
  </div>
</template>

<script>

import PredictedCategorySections from '../../../generic-components/cashflow-types/cashflow-types-base/PredictedCategorySections.vue';
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import Transaction from '../../../generic-components/cashflow-types/cashflow-types-base/Transaction.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';

export default {
  name: 'CashflowTypeTrackingCategory',
  mixins: [CashflowAnalytics],
  components: {
    Transaction,
    ExpenseProgress,
    PredictedCategorySections,

  },
  props: [
    'subtree',
  ],
  computed: {
    CASHFLOW_TYPE() {
      return this.subtree.categoryName;
    },
    TRACKING_CATEGORY() {
      return cashflowViewConsts.cashflowTypes.trackingCategory;
    },
    titles() {
      return {
        expenseProgress: {
          actualsLabel: 'כמה יצא?',
        },
        categorySections: {
          actualsTitle: 'יצא',
          mainTitle: `הוצאות ${this.subtree.categoryName}`,
        },
        cardTitle: `הוצאות ${this.subtree.categoryName}`,
      };
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .past-cashflow-view-container {
    .cashflow-type-tracking-category {
      @include cashflow-card;

      .title {
        @include cashflow-card-title;
      }

      .cashflow-type-color {
        color: $riseup_light_blue;
      }

      .cashflow-type-background-color {
        background-color: $riseup_light_blue;
      }
    }
  }

</style>
